import { PayloadAction } from '@reduxjs/toolkit';

import { ContentAddress, DesignState, MirroringMode } from 'editor/src/store/design/types';

const setMirroringModeReducer = (
  state: DesignState,
  action: PayloadAction<{
    contentAddress: ContentAddress;
    mirroringMode: MirroringMode | undefined;
  }>,
) => {
  const { contentAddress, mirroringMode } = action.payload;
  const { spreadIndex, pageIndex, contentIndex } = contentAddress;

  const content = state?.designData?.spreads[spreadIndex].pages[pageIndex].groups?.content?.[contentIndex];
  if (content) {
    // The OP design template API returns `extra: []` (empty array) for content
    // entries that have no extras, even though the type declares it as
    // `{ mirroring?: MirroringMode } | undefined`. The original check
    // `!content.extra` treats `[]` as truthy and leaves the array in place,
    // then `content.extra.mirroring = ...` triggers Immer's "only supports
    // setting array indices and the 'length' property" error. Replace any
    // non-object value (incl. arrays) with a fresh object before writing.
    if (!content.extra || Array.isArray(content.extra)) {
      content.extra = {};
    }
    content.extra.mirroring = mirroringMode;
  }
};

export default setMirroringModeReducer;
